import { Box, Button } from '@mui/material';
import React, { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { NamespacesList } from 'core/enums/common';

import { ReactComponent as Stars } from 'assets/icons/stars.svg';

interface IGenerateMessageProps {
	handleGenerateAccept: () => void;
	handleGenerateDecline: () => void;
	isDisabled: boolean;
}

export const GenerateMessage: FC<IGenerateMessageProps> = memo(
	({ handleGenerateAccept, handleGenerateDecline, isDisabled }) => {
		const { t: commonTranslate } = useTranslation(NamespacesList['common']);

		return (
			<Box
				sx={{
					display: 'flex',
					justifyContent: 'flex-end',
					marginTop: '12px',
					gap: '8px',
				}}
			>
				<Button
					data-testid={'generate-decline'}
					sx={{
						height: '32px',
						width: '127px',
						borderRadius: '8px',
						textTransform: 'none',
						fontSize: '14px',
						padding: '8px 12px',
						fontWeight: '700',
						color: '#4786FF',
						borderColor: '#4786FF',
						'&:hover': {
							borderColor: '#4786FF',
						},
					}}
					variant="outlined"
					disabled={isDisabled}
					onClick={handleGenerateDecline}
				>
					{commonTranslate('buttons.decline')}
				</Button>
				<Button
					data-testid={'generate-accept'}
					sx={{
						height: '32px',
						width: '127px',
						borderRadius: '8px',
						textTransform: 'none',
						fontSize: '14px',
						padding: '10px 16px',
						fontWeight: '700',
						background: '#4786FF',
						'&:hover': {
							background: '#4786FF',
						},
					}}
					variant="contained"
					disabled={isDisabled}
					onClick={handleGenerateAccept}
				>
					<Stars style={{ marginRight: '4px', width: '20px' }} />
					{commonTranslate('buttons.generate')}
				</Button>
			</Box>
		);
	}
);
